import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a00c5c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "name-box xag-flex-lr" }
const _hoisted_2 = { class: "name xag-ellipsis" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "explain xag-flex-lr" }
const _hoisted_5 = { class: "explain-address xag-ellipsis" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon" }),
  /*#__PURE__*/_createElementVNode("div", null, "暂无维修网点")
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createBlock(_component_van_pull_refresh, {
    modelValue: _ctx.refreshing,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refreshing) = $event)),
    onRefresh: _ctx.onRefresh,
    class: "items-box"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_list, {
        loading: _ctx.loading,
        "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
        finished: _ctx.finished,
        error: _ctx.error,
        "onUpdate:error": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.error) = $event)),
        "error-text": "请求失败，点击重新加载",
        onLoad: _ctx.onLoad,
        class: _normalizeClass({ 'xag-flex-center': !_ctx.items.length && _ctx.finished })
      }, {
        finished: _withCtx(() => [
          (_ctx.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "没有更多了"))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        ]),
        default: _withCtx(() => [
          _createVNode(_component_van_radio_group, {
            modelValue: _ctx.checkItem,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkItem) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_van_radio, {
                  class: "item xag-flex",
                  key: item.guid,
                  name: item.guid,
                  "checked-color": "#07c160"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(item.company_name), 1),
                        _createElementVNode("i", {
                          class: "icon-arrow-right-svg",
                          onClick: _withModifiers(($event: any) => (_ctx.toNetworkDetail(item)), ["stop"])
                        }, null, 8, _hoisted_3)
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(item.area + item.address), 1),
                        _createElementVNode("div", null, _toDisplayString(item.dis) + "km", 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["loading", "finished", "error", "onLoad", "class"])
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
}